(function () {
  if (window.__floatingCartInit) return;
  window.__floatingCartInit = true;

  var floatEl = document.getElementById('site-cart-float');
  if (!floatEl) return;

  var countEl = floatEl.querySelector('[data-header-cart-count]');
  if (!countEl) return;

  function pop() {
    floatEl.classList.remove('is-popping');
    void floatEl.offsetWidth;
    floatEl.classList.add('is-popping');
  }

  var lastCount = parseInt(countEl.textContent, 10) || 0;

  var observer = new MutationObserver(function () {
    var newCount = parseInt(countEl.textContent, 10) || 0;
    if (newCount > 0) {
      var wasHidden = !floatEl.classList.contains('is-visible');
      floatEl.classList.add('is-visible');
      if (wasHidden || newCount > lastCount) pop();
    }
    lastCount = newCount;
  });

  observer.observe(countEl, { childList: true, characterData: true, subtree: true });
})();
